import { cn } from './cn';

interface SpinnerProps {
  className?: string;
  label?: string;
}

/** Minimal inline loading spinner. */
export function Spinner({ className, label }: SpinnerProps) {
  return (
    <span className={cn('inline-flex items-center gap-2 text-muted', className)} role="status">
      <svg
        className="h-4 w-4 animate-spin text-brand-400"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-90"
          fill="currentColor"
          d="M4 12a8 8 0 0 1 8-8v4a4 4 0 0 0-4 4H4z"
        />
      </svg>
      {label ? <span className="text-xs">{label}</span> : null}
    </span>
  );
}
